export default {
  name: 'software-license',
  translationKey: 'software-license-module',
  routePrefix: 'software-license',
  routeNamePrefix: 'software-license',
  directRoutesAvailable: true,
}
